import Button from '@/components/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/sharp-solid-svg-icons'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './InstagramFeed.module.scss'

export default function InstagramFeed() {
  const [photos, setPhotos] = useState([])

  useEffect(() => {
    const fetchInstagramPhotos = async () => {
      try {
        const response = await fetch('/api/faust/instagram')
        if (!response.ok) throw new Error('Failed to fetch Instagram photos')

        const data = await response.json()
        setPhotos(data)
      } catch (err) {
        console.log(err.message)
      }
    }

    fetchInstagramPhotos()
  }, [])

  const displayPosts = photos.data || []

  return (
    <div className={styles.instagramFeed}>
      <div className="container">
        <div className={styles.photoFeed}>
          <h2 data-aos="fade-up">Life at Integrity</h2>
          <Button href="https://www.instagram.com/integrity_xd/" target="_blank">
            View All posts <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        </div>
        <div id="contentSwiper">
          {displayPosts.length > 0 && (
            <Swiper
              navigation={{ prevEl: '.prev', nextEl: '.next' }}
              slidesPerView={1}
              spaceBetween={30}
              loop={true}
              speed={600}
              className={styles.swiper}
              modules={[Navigation]}
              breakpoints={{
                767: {
                  slidesPerView: 2
                },
                820: {
                  slidesPerView: 5
                }
              }}
            >
              {displayPosts.map(({ id, permalink, media_url, caption }) => (
                <SwiperSlide key={id} className={styles.swiperSlide}>
                  <a href={permalink} key={id} target="_blank" rel="noopener noreferrer">
                    <Image
                      src={media_url}
                      alt={caption || 'Instagram post'}
                      width={300}
                      height={300}
                      className={styles.instagramImage}
                      sizes="(max-width: 768px) 80vw, (max-width: 820px) 50vw, 20vw"
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
        <div className="prev">
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
        <div className="next">
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>
    </div>
  )
}
